module.exports = __webpack_public_path__ + "img/preloader_icon.52f57f6e.svg";